import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import http from '../../../lib/http/index.js';
import { createSelector } from 'reselect';

const fetchRolesData = async () => {

};

// Crear una función selector memoizada utilizando createSelector
export const selectRolesData = createSelector(
    state => state.roles.data,
    data => data
);

// Crear una función selector memoizada utilizando createSelector
export const selectRolesFetching = createSelector(
    state => state.roles.fetching,
    fetching => fetching
);

export const getRolesData = createAsyncThunk('GET_ROLES', async (payload, thunkAPI) => {
    const permisos =  (await http.TABLE('/permisos')).body;
    const permisosRolesMap =  (await http.TABLE('/permisos_roles_map')).body;
    const personas =  (await http.TABLE('/personas')).body;
    const rolesPersonasMap = (await http.TABLE('/personasrolesmap')).body;
    const roles = (await http.TABLE('/roles')).body;
    const data = {
        permisos,
        rolesPersonasMap,
        permisosRolesMap,
        personas,
        roles
    };
    return data
});

export const addRol = createAsyncThunk('POST_ROLES', async (payload, thunkAPI) => {
    let res = (await http.POST('/roles', payload)).body;
    await thunkAPI.dispatch(getRolesData()).unwrap();
    return res;
});
export const editRol = createAsyncThunk('PUT_ROLES', async (payload, thunkAPI) => {
    let res = (await http.PUT('/roles', payload)).body;
    await thunkAPI.dispatch(getRolesData()).unwrap();
    return res

});
export const deleteRol = createAsyncThunk('DELETE_ROLES', async (payload, thunkAPI) => {
    const res = (await http.DELETE(`/roles`, payload)).body
    await thunkAPI.dispatch(getRolesData()).unwrap();
    return res

});
const initialState = {
    //pendingRequests: 0,
    fetching: 0,
    error: null,
    message: null,
    data: {}
};

const rolesSlice = createSlice({
    name: 'roles',
    initialState,
    reducers: {
        cleanError: (state, action) => ({ ...state, error: null }),
        cleanMessage: (state, action) => ({ ...state, message: null }),
        resetData: (state, action) => ({ ...initialState }),
    },
    extraReducers: {
        [getRolesData.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [getRolesData.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: action }),
        [getRolesData.fulfilled]: (state, action) => ({ ...state, data: action.payload, fetching: state.fetching - 1 }),

        [addRol.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [addRol.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo procesar la petición!" }),
        [addRol.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "Rol creado!" : null,
            error: action.payload.status != 200 ? "No se pudo crear el rol!" : null,
        }),
        [editRol.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [editRol.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo procesar la petición!" }),
        [editRol.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "Rol editado!" : null,
            error: action.payload.status != 200 ? "No se pudo editar el rol!" : null,
        }),
        [deleteRol.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [deleteRol.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo procesar la petición!" }),
        [deleteRol.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "Rol eliminado!" : null,
            error: action.payload.status != 200 ? "No se pudo eliminar el rol!" : null,
        }),

    },
})

export const { cleanError, cleanMessage, resetData } = rolesSlice.actions
export default rolesSlice.reducer;